import PropTypes from 'prop-types';

import { WatchingWatchRow } from './WatchingWatchRow';

export const WatchingWatchesList = ({ watches = [], isLoading = false }) => {
    if (isLoading) {
        return (
            <div className="sds_watching-watches-list">
                <div className="sds_watching-watches-list__empty">Loading watches…</div>
            </div>
        );
    }

    if (watches.length === 0) {
        return (
            <div className="sds_watching-watches-list">
                <div className="sds_watching-watches-list__empty">No watched resources.</div>
            </div>
        );
    }

    return (
        <div className="sds_watching-watches-list">
            <div className="sds_watching-watches-list__rows">
                {watches.map((watch) => (
                    <WatchingWatchRow key={watch.watchId} watch={watch} />
                ))}
            </div>
        </div>
    );
};

WatchingWatchesList.propTypes = {
    watches: PropTypes.arrayOf(
        PropTypes.shape({
            watchId: PropTypes.string.isRequired,
        }),
    ),
    isLoading: PropTypes.bool,
};
